import { z } from 'zod';

export const ratingFormSchema = z
  .object({
    rating: z.number(),
    tipInput: z
      .union([
        z.string().transform((val) => {
          if (val === '' || val === null || val === undefined) {
            return undefined;
          }
          const num = Number(val);
          return isNaN(num) ? undefined : num;
        }),
        z.number(),
        z.undefined(),
      ])
      .optional()
      .refine(
        (val) => {
          if (val !== undefined && val !== null) {
            return val >= 5000 && val <= 100000;
          }
          return true;
        },
        {
          message: 'Tip từ 5.000đ đến 100.000đ',
        }
      ),
    selectedTipOption: z.number().nullable(),
    selectedBadges: z.array(z.string()),
    selectedReasons: z.array(z.string()),
    comment: z
      .string()
      .optional()
      .refine(
        (val) => {
          if (val && val.trim().length > 0) {
            return val.trim().length >= 6;
          }
          return true;
        },
        {
          message: 'Nhận xét phải có ít nhất 6 ký tự',
        }
      ),
  })
  .refine(
    (data) => {
      // If rating is negative (1-3), require either selected reasons or comment
      if (data.rating <= 3) {
        return (
          data.selectedReasons.length > 0 ||
          (data.comment && data.comment.length >= 6)
        );
      }
      return true;
    },
    {
      message: 'Vui lòng chọn lý do hoặc để lại nhận xét cho đánh giá tiêu cực',
      path: ['selectedReasons'], // This will show the error on the selectedReasons field
    }
  );

export type RatingFormData = z.infer<typeof ratingFormSchema>;

export const RATING_LABELS = [
  '',
  'Rất tệ',
  'Tệ',
  'Không hài lòng',
  'Bình thường',
  'Tốt',
];

export const RATING_THRESHOLDS = {
  POSITIVE: 4, // 4-5 stars = positive rating
  NEGATIVE: 3, // 1-3 stars = negative rating
} as const;

export const DEFAULT_FORM_VALUES: RatingFormData = {
  rating: 5,
  tipInput: undefined,
  selectedTipOption: null,
  selectedBadges: [],
  selectedReasons: [],
  comment: '',
};
